import { isDateTermV2 } from '../../../../domain/value-object/DateTermV2'
import { isDateTimeRangeV2 } from '../../../../domain/value-object/DateTimeRangeV2'
import { SingleSheetPropertyValueType } from '../model/singleSheetProperty'
import { FormCellType } from '../table/model'
import { getSlackUserSelectionState } from './slackUserSelection'

// 値の型ごとに「空」の意味が違う（テキストは空文字も空、期間は片側だけでも空、
// 複数選択は空配列も空）ためセル型で分岐する。
export const isRequiredValueMissing = (
  type: FormCellType,
  value: SingleSheetPropertyValueType
): boolean => {
  switch (type) {
    case 'TEXT':
    case 'EMAIL':
    case 'MULTI_LINE_TEXT':
    case 'GITHUB_USER_NAME':
      return value === undefined || value === ''
    case 'MULTI_SELECT':
      return value === undefined || (Array.isArray(value) && value.length === 0)
    case 'NUMBER':
    case 'DATE':
    case 'DATE_TIME':
    case 'CHECKBOX':
    case 'SELECT':
    case 'ENTITY_SEARCH':
    case 'TICKET_LIST':
      return value === undefined
    case 'SLACK_USER':
      return getSlackUserSelectionState(value) !== 'complete'
    case 'DATE_TERM': {
      // 必須の期間は開始日・終了日の両方が必要。
      return !isDateTermV2(value) || !value.startDate || !value.endDate
    }
    case 'DATE_TIME_RANGE': {
      // 必須の期間は開始日時・終了日時の両方が必要。
      return (
        !isDateTimeRangeV2(value) || !value.startDateTime || !value.endDateTime
      )
    }
    case 'MULTI_ENTITY_SEARCH':
    case 'WORKLOAD':
    case 'PROJECT_MEMBER':
    case 'ICON':
      return false
    default: {
      // FormCellTypeに新しい型を追加してcaseの追加を忘れると、ここで
      // コンパイルエラーになる（黙って必須チェックが無効化されるのを防ぐ）。
      const exhaustiveCheck: never = type
      return exhaustiveCheck
    }
  }
}
